import script from "./ProductDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailPage.vue?vue&type=style&index=0&id=6daabce8&setup=true&lang=css"

const __exports__ = script;

export default __exports__